import { useFormatMessage } from '../../../../intl/intl'

import { storeStatusDropdownTextIds as ssDdBtnTextIds } from '../../constants'

function useTexts() {
  return {
    manageStoresBtn: useFormatMessage({ id: ssDdBtnTextIds.manageStores }),
  }
}

export const hooks = {
  useTexts,
}
